module.exports = __webpack_public_path__ + "img/trinidad-and-tobago.b4c97e5e.svg";